<template>
  <div class="iBannerBg">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :space-between="50"
      :pagination="false"
      :autoplay="false"
      :navigation="true"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      id="iBannerL"
    >
      <swiper-slide><img src="@/assets/images/i_banner_1.jpg" alt="thermaltake"></swiper-slide>

    </swiper>
    <div class="shadow"></div>
  </div>
</template>

<style>
.swiper img {
  display: block;
}
.swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
  bottom: 0px;
}
.swiper-pagination-bullet-active {
  background: #c52300;
}
.swiper-pagination-bullet {
  width: 30px;
  height: 5px;
  border-radius: 0;
  margin: 0 !important;
  vertical-align: bottom;
}
/* 箭頭 */
.iBannerBg .swiper-button-prev, .iBannerBg .swiper-button-next {
  display: block;
  position: absolute;
  top: 50%;
  margin: -14px 0 0 0;
  width: 16px;
  height: 28px;
  text-indent: -9999px;
  background: url(@/assets/images/i_brand_left.png) no-repeat;
  cursor: pointer;
  -webkit-transition: .2s ease-in-out;
  transition: .2s ease-in-out;
}
.iBannerBg .swiper-button-prev:after, .iBannerBg .swiper-button-next:after {
  content: none;
}
.iBannerBg .swiper-button-next {
  background: url(@/assets/images/i_brand_right.png) no-repeat;
  left: inherit;
}
</style>

<script>
/* https://swiperjs.com/vue */
// 安裝：npm i swiper
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper' // 要Autoplay，要載入
import { Swiper, SwiperSlide } from 'swiper/vue'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  inject: ['emitter'], // 內層元件用Inject的方式把emitter讀進來
  mounted () {
    // let refName = [...this.$refs[].offsetTop];
    // let distence = refName.offsetTop;
    // console.log('$refs.judges', refName, this.$refs.judges, this.$refs)
    // this.scrollToId;
    this.emitter.on('emitLinkId', (data) => {
      // this.$router.push(`/`);
      // let refName = this.$refs[data];
      console.log('接收emitter', data)
      this.refName = data
      console.log('this.refName', this.refName)
      // const linkId = this.$refs[data];
      // const linkId = this.$refs.judges;
      // console.log('linkId', linkId)
      // const top = linkId.offsetTop;
      this.scrollToId
      // window.scrollTo(0, 500);
    })
  },
  setup () {
    const onSwiper = (swiper) => {
      // console.log(swiper);
    }
    const onSlideChange = () => {
      // console.log('slide change');
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay] // 要Autoplay，要載入
    }
  }
}
</script>
